export const palette = {
  alternate: {
    main: '#F9F6FF',
    light: '#F9F8F8',
    dark: '#E5EAF4',
  },
  cardShadow: 'rgba(23, 70, 161, .11)',
  type: 'light',
  primary: {
    main: '#7BD6D0',
    contrastText: '#183B56',
    light: '#7BD6D01a',
    hover: '#1A3743',
  },
  secondary: {
    main: '#0074BE',
    contrastText: '#FFFFFF',
    text: '#BA9268',
  },
  text: {
    primary: '#222222',
    detail: '#374151',
    secondary: '#64748B',
    dark: '#008080',
    disabled: '#CCC',
    highlight: '#FFF',
    success: '#1CA179',
    border: '#E5EAF4',
    heading: '#0F0F0F',
    tertiary: '#9CA3AF',
    normal: '#45556C',
  },
  divider: 'rgba(0, 0, 0, 0.12)',
  background: {
    main: '#FFF7F0',
    paper: '#FFF',
    default: '#FFF',
    footer: '#1A3743',
    level2: '#f7f8fb',
    level1: '#FFF',
    tableHead: '#1A3743',
    tableSubhead: '#F7F7F7',
    border: 'linear-gradient(to right, #1A3743 0%, #1A3743 20%, #F9DBD3 20%, #F9DBD3 40%, #FEA7A1 40%, #FEA7A1 60%, #7BD6D0 60%, #7BD6D0 80%, #E8C8B3 80%, #E8C8B3 100%)',
    stepper: '#D8B795',
    tableAlternate: '#F8F8F8',
    alternate: '#E3F1FD',
    success: '#DBEFDC',
    error: '#FFEAEA',
    secondary: '#F8D859',
    serviceIcon: '#F8FAFC',
    tertiary: '#F9FAFB',
    serviceIconActive: '#E8F6FF',
  },
  border: {
    primary: '#D1D5DB',
    field: '#E3E5E8',
    subtle: '#E2E8F0',
    card: '#EBEBEF',
    detailCard: '#FFF1E5',
  },
  brand: {
    main: '#0074BE',
    hover: '#184A8E',
    surface: '#E8F6FF',
  },
  icon: {
    primary: '#2B918A',
    tertiary: '#4B5563',
  },
  verticalBar: {
    used: '#7BD6D0',
    unused: '#7BD6D01a',
    unlimited: '#C0C0C0',
  }
};
